import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ManageLlmStrategiesLandingScreen } from "./ManageLlmStrategiesLandingScreen";
import { ManageLlmStrategiesParamList } from "../../../../types";
import { CreateLlmStrategyRootScreen } from "./CreateLlmStrategyRootScreen";
import { SelectLlmQuickWinStrategyScreen } from "./SelectLlmQuickWinStrategyScreen";
import { ViewLlmStrategyRootScreen } from "./ViewLlmStrategyRootScreen";
import { Colors } from "react-native-ui-lib";
import { AcceptAiTermsScreen } from "./AcceptAiTermsScreen";
import { ManageQuickWinHandlerScreen } from "./ManageQuickWinHandlerScreen";
import { SelectImageQuickWinStrategyScreen } from "./SelectImageQuickWinStrategyScreen";

const Stack = createStackHeaderNavigator<ManageLlmStrategiesParamList>();

export interface ManageLlmStrategiesRootScreenProps
  extends StackScreenProps<any, "ManageLlmStrategiesRootScreen"> {}

export const ManageLlmStrategiesRootScreen =
  ({}: ManageLlmStrategiesRootScreenProps) => {
    return (
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: true,
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            name="ManageLlmStrategiesLandingScreen"
            component={ManageLlmStrategiesLandingScreen}
          />
          <Stack.Screen
            name="SelectLlmQuickWinStrategyScreen"
            component={SelectLlmQuickWinStrategyScreen}
          />
          <Stack.Screen
            name="SelectImageQuickWinStrategyScreen"
            component={SelectImageQuickWinStrategyScreen}
          />
          <Stack.Screen
            name="ManageQuickWinHandlerScreen"
            component={ManageQuickWinHandlerScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerShown: false,
          }}
        >
          <Stack.Screen
            name="CreateLlmStrategyRootScreen"
            component={CreateLlmStrategyRootScreen}
          />
          <Stack.Screen
            name="ViewLlmStrategyRootScreen"
            component={ViewLlmStrategyRootScreen}
          />
        </Stack.Group>

        <Stack.Group
          screenOptions={{
            presentation: "modal",
            animationEnabled: true,
            cardStyle: { backgroundColor: Colors.surface },
            title: "",
            headerLeft: () => null,
          }}
        >
          <Stack.Screen
            name="AcceptAiTermsScreen"
            component={AcceptAiTermsScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    );
  };
